import axios from "axios";

export async function createLoyaltyMembership(reqData) {
  return axios
    .post(`/loyalty-memberships/`, reqData)
    .then(({ data }) => {
      return data;
    })
    .catch((err) => {
      throw err;
    });
}

export async function createThirdPartyLoyaltyMembership(reqData) {
  const { data } = await axios.post(
    `/loyalty-memberships/third-party-loyalty-membership/`,
    reqData
  );

  const res = data.response?.[0];

  if (res) {
    if (res.success) {
      return {
        ...data.response[0],
        confirmed_by_third_party_api: true,
        phone_match: true,
      }
    } else {
      // this will be the error flow
      return {
        ...data.response[0],
      }
    }
  } else {
    throw new Error(`We have an issue. Please talk to your dealer.`);
  }
}

export async function thirdPartyUserLookup(reqData) {
  return axios
    .post(`/loyalty-memberships/third-party-lookup/`, reqData)
    .then(({ data }) => {
      return data.response;
    })
    .catch((err) => {
      throw err;
    });
}
